import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface ProjectRepository {
  project_id: string;
  repository_id: string;
  is_primary: boolean;
  added_at: string;
}

export function useProjectDetail(projectId: string | null) {
  const query = useQuery({
    queryKey: queryKeys.projects.repositories(projectId ?? ""),
    queryFn: () =>
      api<ProjectRepository[]>(`/api/v2/projects/${projectId}/repositories`),
    enabled: projectId !== null,
  });

  const refetch = useCallback(() => {
    void query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.refetch]);

  return {
    repositories: query.data ?? [],
    loading: query.isLoading,
    error: query.error ? "Failed to load project details" : "",
    refetch,
  };
}
